var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('bn-aside',{on:{"onPackupClick":_vm.onPackupClick}}),_c('div',{staticClass:"bn-main"},[_c('div',{staticClass:"bn-main-c",style:({ 'margin-left': _vm.isPackup ? 0 : 0 + 'px' })},[_c('nav',{staticClass:"bn-nav"},[_c('bn-nav')],1),_c('div',{staticClass:"main-c-w"},[_c('MainContent')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }